import { render, staticRenderFns } from "./TopCenter.vue?vue&type=template&id=2e671474&scoped=true"
import script from "./TopCenter.vue?vue&type=script&lang=js"
export * from "./TopCenter.vue?vue&type=script&lang=js"
import style0 from "./TopCenter.vue?vue&type=style&index=0&id=2e671474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e671474",
  null
  
)

export default component.exports